export default "__VITE_ASSET__DEIIMMER__"